// extracted by mini-css-extract-plugin
export var deleteModal = "_ef-0";